import { Component } from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import BackLink from '../../common/back-link/index';
import PageTitle from '../../common/page-title/index';
import UpdateLevelForm from './update-level-form';

class UpdateLevelPage extends Component {
  render() {
    const {
      levelValues, outletValue, outletValues, handleSelectChange,
      handleSubmit, updateButtonDisabled, backLinkUrl, handleSelectInputChange
    } = this.props;

    return (
      <Container fluid className="levels">
        <Row>
          <Col lg={12}>
            <BackLink href={backLinkUrl}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              Update level
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <UpdateLevelForm
              handleSelectChange={handleSelectChange}
              handleSelectInputChange={handleSelectInputChange}
              handleSubmit={handleSubmit}
              levelValues={levelValues}
              outletValue={outletValue}
              outletValues={outletValues}
              updateButtonDisabled={updateButtonDisabled}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default UpdateLevelPage;
